<template>
  <div class="d-flex justify-center align-center" style="height: 100%">
    <v-dialog v-model="changePasswordDialog" persistent max-width="450">
      <v-card class="card pa-4">
        <h2 class="text-center">{{ $t('change_password_title') }}</h2>
        <p>{{ $t('change_password_content') }}</p>

        <v-form ref="changeForm">
          <v-text-field
            hide-details="auto"
            v-model="newPassword"
            placeholder="********"
            :rules="[
              (v) => !!v || 'Campo obrigatório',
              (v) =>
                v != user.password ||
                'A senha não pode ser igual a senha anterior',
              (v) => /\d/.test(v) || 'Mínimo de um número',
              minLength(this.newPassword),
              specialCharacters(this.newPassword),
              uppercaseLetter(this.newPassword),
            ]"
            required
            class="ma-1"
            :label="$t('Defina sua nova senha')"
            :append-icon="
              changeShow ? 'mdi-eye-outline' : 'mdi-eye-off-outline'
            "
            :type="changeShow ? 'text' : 'password'"
            @click:append="changeShow = !changeShow"
          ></v-text-field>

          <v-text-field
            hide-details="auto"
            placeholder="********"
            :rules="[(v) => v == newPassword || 'Senhas não coincidem!']"
            class="ma-1"
            required
            :label="$t('Confirmação da senha')"
            :append-icon="
              changeShow2 ? 'mdi-eye-outline' : 'mdi-eye-off-outline'
            "
            :type="changeShow2 ? 'text' : 'password'"
            @click:append="changeShow2 = !changeShow2"
          ></v-text-field>
        </v-form>

        <div class="d-flex justify-end align-center mt-4">
          <v-btn
            color="primary"
            class="ma-0"
            depressed
            @click="changePassword"
            :loading="changeLoading"
            >{{ $t('save') }}</v-btn
          >
        </div>
      </v-card>
    </v-dialog>

    <div class="conteudo">
      <div class="info">
        <InfoBlock
          :styleClass="styleClass"
          class="info-block"
          :title="$t('Bem-vindo')"
          :description="
            $t('Entre com usuário e senha para ter acesso ao sistema.')
          "
        />
      </div>

      <div class="card-div">
        <TCard
          title="Login"
          :titlePage="$t('Bem-vindo')"
          :descriptionPage="
            $t('Entre com usuário e senha para ter acesso ao sistema')
          "
        >
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-window v-model="step" touchless>
              <v-window-item :value="0">
                <v-row class="flex-column" align="start">
                  <v-col>
                    <v-text-field
                      hide-details="auto"
                      v-model="user.username"
                      placeholder="willie.jennings@example.com"
                      :rules="[(v) => !!v || 'E-mail requerido']"
                      @keydown.enter="login"
                      required
                      label="Usuário"
                      :append-icon="'mdi-account-outline'"
                    />
                  </v-col>
                </v-row>

                <v-row class="flex-column senha" align="start">
                  <v-col class="mb-4">
                    <v-text-field
                      hide-details="auto"
                      v-model="user.password"
                      placeholder="********"
                      :rules="passwordRules"
                      @keydown.enter="login"
                      required
                      :label="$t('Senha')"
                      :append-icon="
                        show ? 'mdi-eye-outline' : 'mdi-eye-off-outline'
                      "
                      :type="show ? 'text' : 'password'"
                      @click:append="show = !show"
                    />
                  </v-col>

                  <v-col class="d-flex justify-center">
                    <div id="recaptcha-container"></div>
                  </v-col>
                </v-row>
              </v-window-item>

              <v-window-item :value="1">
                <v-row class="flex-column senha" align="start">
                  <v-col>
                    <v-autocomplete
                      :label="$t('Instituição')"
                      append-icon="mdi-chevron-down"
                      hide-details="auto"
                      v-model="institution"
                      :items="institutions"
                      item-text="name"
                      return-object
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-window-item>
            </v-window>
          </v-form>

          <div class="btn-forgot-password my-12">
            <span @click="$router.push({ name: 'ForgotPassword' })">
              {{ $t('Esqueceu sua senha?') }}
            </span>
          </div>

          <v-btn
            depressed
            :loading="loading"
            :disabled="!valid"
            block
            class="primary-button"
            @click="step == 1 ? setInst() : login()"
          >
            Login
          </v-btn>
        </TCard>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from '../../../services/ApiService'
import InfoBlock from './components/infoBlock.vue'
import TCard from '../../../components/T/TCardAuth.vue'
import Component from '../../../components/toast.vue'
import CryptoJS from 'crypto-js'

export default {
  components: {
    InfoBlock,
    TCard,
  },

  data() {
    return {
      changeLoading: false,
      changePasswordDialog: false,
      step: 0,
      show: false,
      changeShow: false,
      changeShow2: false,
      loading: false,
      valid: true,
      styleClass: { color: '#fff' },
      apiService: new ApiService(),
      user: {
        username: '',
        password: '',
      },
      passwordRules: [(v) => !!v || 'Senha requerida'],
      emailRules: [
        (v) => !!v || 'E-mail requerido',
        (v) => /.+@.+\..+/.test(v) || 'E-mail inválido',
      ],
      institution: {},
      institutions: [],
      isLogged: false,
      userLogged: {},
      token: '',
      validTo: '',
      openPatchNotes: false,
      newPassword: '',
    }
  },

  mounted() {
    try {
      grecaptcha.ready(function () {
        grecaptcha.render('recaptcha-container', {
          sitekey: '6Lc9yr8qAAAAAMoQnqQPINTl8QROzeiZTq7qtEg4',
        })
      })
    } catch {
      window.location.reload()
    }
  },

  methods: {
    encryptPassword(password) {
      const base64Key = 't5PSvsnXASeiseBli5x7rqwEs40IDxXS6+pNR854W3o='
      const secretKey = CryptoJS.enc.Base64.parse(base64Key)
      const ciphertext = CryptoJS.AES.encrypt(password, secretKey, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      }).toString()
      return ciphertext
    },

    specialCharacters(v) {
      if (v.length) {
        const specialCharacters = /[!@#$%^&*()_+[\]{};:'"<>,.?/~\\-]/

        if (specialCharacters.test(v) == false)
          return 'Mínimo de um caractere especial'

        return true
      }
      return true
    },

    uppercaseLetter(v) {
      if (v.length) {
        const uppercaseLetter = /[A-Z]/

        if (uppercaseLetter.test(v) == false)
          return 'Mínimo de uma letra maiuscula'

        return true
      }
      return true
    },

    minLength(v) {
      if (v.length) {
        if (v.length < 8) {
          return 'Mínimo de 8 caractéres'
        }
      }
      return true
    },

    async setInst() {
      localStorage.removeItem('institution')

      this.$i18n.locale = this.institution.locale
        ? this.institution.locale
        : 'pt'
      localStorage.removeItem('locale')
      localStorage.setItem('locale', this.$i18n.locale)

      this.$store.commit(
        'SET_INSTITUTION_USER',
        JSON.stringify(this.institution)
      )

      await this.apiService
        .get(`called/pendent-rating/${this.institution.id}`)
        .then((response) => {
          this.userLogged.pendingCalleds = response.content

          localStorage.removeItem('user')
          localStorage.setItem('user', JSON.stringify(this.userLogged))

          if (
            this.userLogged.pendingCalleds &&
            this.userLogged.pendingCalleds.length > 0
          ) {
            this.$toast(Component, {
              position: 'top-right',
              timeout: 10000,
              closeOnClick: false,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: false,
              draggablePercent: 0.6,
              showCloseButtonOnHover: true,
              closeButton: 'button',
              icon: true,
              rtl: false,
            })
          }
        })

      if (this.institution.userType == 6) {
        this.$router.push('/calleds')
      } else {
        this.$router.push('/serviceOrders')
      }
    },

    async login() {
      if (this.$refs.form.validate()) {
        let recaptchaResponse = null
        try {
          recaptchaResponse = grecaptcha.getResponse()
          if (!recaptchaResponse) {
            this.$toast.warning(
              'Por favor, complete o reCAPTCHA para prosseguir'
            )
            return
          }
        } catch {
          window.location.reload()
        }

        this.loading = true
        this.user.username = this.user.username.trim().toLowerCase()
        const password = this.encryptPassword(this.user.password)

        await this.apiService
          .post('auth/signin-captcha', {
            username: this.user.username,
            password,
            recaptcha: recaptchaResponse,
          })
          .then(async (result) => {
            this.userLogged = result.content.user
            this.token = result.content.token
            this.validTo = result.content.validTo
            this.openPatchNotes = result.content.openPatchNotes

            if (result.content.haveToChangePassword) {
              this.loading = false
              this.changePasswordDialog = true
              return
            }

            localStorage.removeItem('user')
            localStorage.removeItem('token')
            localStorage.removeItem('validTo')
            const user = JSON.stringify(result.content.user)

            this.$store.commit('SET_LOGGED_USER', user)
            this.$store.commit('SET_CURRENT_TOKEN', this.token)
            this.$store.commit('SET_EXPIRES_TOKEN', this.validTo)

            await this.getInstitutions()
            localStorage.setItem(
              'institution',
              JSON.stringify(this.institutions[0])
            )

            const qrCode = localStorage.getItem('equipmentIdQrCode')

            if (qrCode) {
              localStorage.removeItem('equipmentIdQrCode')
              const equipmentInstitutionId = localStorage.getItem(
                'equipmentInstitutionId'
              )
              const institution = this.institutions.find(
                (institution) => institution.id == equipmentInstitutionId
              )
              localStorage.setItem('institution', JSON.stringify(institution))

              this.$router.push('/aboutEquipment/' + qrCode)
            }

            const equipment = JSON.parse(localStorage.getItem('equipmentId'))
            const calledId = this.$route.query.calledId

            if (equipment) {
              this.$router.push('/newCalled')
            } else if (calledId) {
              this.$router.push('/calleds?calledId=' + calledId)
            } else {
              if (this.equipmentId) {
                this.$router.push({
                  name: 'aboutEquipmentQrCode',
                  props: this.equipmentId,
                })
              }
            }

            if (this.institution.userType == 6) {
              this.$router.push('/calleds')
            }

            this.step = 1

            this.loading = false

            this.$i18n.locale =
              this.institution && this.institution.locale
                ? this.institution.locale
                : 'pt'
            localStorage.removeItem('locale')
            localStorage.setItem('locale', this.$i18n.locale)

            setTimeout(() => {
              this.$root.$emit('OpenNotes', result.content.openPatchNotes)
            }, 500)
          })
          .catch((err) => {
            localStorage.removeItem('token')
            localStorage.removeItem('expires')
            localStorage.removeItem('user')
            localStorage.removeItem('institution')
            this.loading = false
          })
      }
    },

    async changePassword() {
      if (!this.$refs.changeForm.validate()) {
        return
      }

      this.changeLoading = true

      this.apiService
        .post('user/password/update', {
          id: this.userLogged.id,
          currentPassword: this.user.password,
          newPassword: this.newPassword,
        })
        .then(async (response) => {
          this.changePasswordDialog = false
          this.changeLoading = false
          localStorage.removeItem('user')
          localStorage.removeItem('token')
          localStorage.removeItem('validTo')
          const user = JSON.stringify(this.userLogged)

          this.$store.commit('SET_LOGGED_USER', user)
          this.$store.commit('SET_CURRENT_TOKEN', this.token)
          this.$store.commit('SET_EXPIRES_TOKEN', this.validTo)

          const qrCode = localStorage.getItem('equipmentIdQrCode')

          if (qrCode) {
            localStorage.removeItem('equipmentIdQrCode')
            this.$router.push('/aboutEquipment/' + qrCode)
          }

          const equipment = JSON.parse(localStorage.getItem('equipmentId'))
          const calledId = this.$route.query.calledId

          if (equipment) {
            this.$router.push('/newCalled')
          } else if (calledId) {
            this.$router.push('/calleds?calledId=' + calledId)
          } else {
            if (this.equipmentId) {
              this.$router.push({
                name: 'aboutEquipmentQrCode',
                props: this.equipmentId,
              })
            }
          }

          if (this.institution.userType == 6) {
            this.$router.push('/calleds')
          }

          this.getInstitutions()

          this.step = 1

          this.loading = false

          this.$i18n.locale =
            this.institution && this.institution.locale
              ? this.institution.locale
              : 'pt'
          localStorage.removeItem('locale')
          localStorage.setItem('locale', this.$i18n.locale)

          setTimeout(() => {
            this.$root.$emit('OpenNotes', this.openPatchNotes)
          }, 500)
        })
        .catch(() => {
          this.changeLoading = false
        })
    },

    async getInstitutions() {
      this.institutions = []
      this.loading = true
      await this.apiService
        .get('institution/list-with-user-type')
        .then((response) => {
          this.institutions = response.content
        })
        .catch((err) => {})

      this.loading = false
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/sass/variables.scss';
.login-container {
  padding: 1.5rem;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
}

.conteudo {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  padding: 0.5rem;
  gap: 1rem;
  position: relative;

  .info-block {
    background: none !important;
    color: white;
    z-index: 10;
  }

  .info {
    flex: 1 1 500px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: none !important;
  }
  .card-div {
    flex: 1 1 400px;
    z-index: 2;
    .login-btn {
      background: $blue-1 !important;
      width: 100%;
      margin: 1rem 0;
    }
    .btn-forgot-password {
      text-align: center;
      span {
        text-decoration-line: underline;
        cursor: pointer;
        color: $blue-2;
        font-weight: 600;
      }
    }
  }
}

@media screen and (max-width: $mobile-1) {
  .info {
    display: none !important;
  }
}
</style>
